/**
 * Cart-page interactive — extracted from inline <script> in sections/main-cart.liquid.
 * Loaded only on the /cart template (see theme.liquid).
 * Handles: discount-code submit, note + gift message auto-save (debounced).
 */
(function () {
  // ── Discount code form ──
  var form = document.querySelector('[data-cart-discount-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input');
      var code = input && input.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
    });
  }

  // ── Auto-save note + gift message (debounced; fires on blur or 1s idle) ──
  var noteInput = document.querySelector('[data-cart-note-input]');
  var giftInput = document.querySelector('[data-cart-gift-input]');
  var saveTimer = null;

  function saveCart() {
    var body = {};
    if (noteInput) body.note = noteInput.value;
    if (giftInput) body.attributes = { 'Gift message': giftInput.value };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  }

  function scheduleSave() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(saveCart, 1000);
  }

  if (noteInput) {
    noteInput.addEventListener('input', scheduleSave);
    noteInput.addEventListener('blur', function () { clearTimeout(saveTimer); saveCart(); });
  }
  if (giftInput) {
    giftInput.addEventListener('input', scheduleSave);
    giftInput.addEventListener('blur', function () { clearTimeout(saveTimer); saveCart(); });
  }
})();
